import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import BoardCard from "../BoardCard";
// import geojson from '../census_block_ca.json'
import exportImg from "../../images/file-export-solid.svg"
import shareImg from "../../images/share-solid.svg"
import {ReactComponent as CopySVG} from "../../images/copy-regular.svg"
import {Alert, Button, OverlayTrigger, Popover} from "react-bootstrap";
import {ReactComponent as HeartSVG} from "../../images/heart.svg";
import {boardMatchesSearch, ActivityTracker} from "../../helpers/Helpers";
import {Link} from "react-router-dom";
import AutozoneImg from "../img/company_logos/autozone.jpg"
import OreillyImg from "../img/company_logos/oreilly.jpg"
import MedPotCross from "../img/company_logos/medpotcross.png"
import loadingSvg from "../../images/loading.svg";
import BoardCardTreeWrapper from '../BoardCardTreeWrapper';
import InviteOwnerForm from './InviteOwnerForm';
import Axios from 'axios';

const mapStyles = {
    width: '100%',
    height: '100%'
};

export class MapContainer extends Component {

    state = {
        showPOIs: false,
        error: null,
    }
    complianceOverlays = [];
    censusOverlays = [];
    metroMediaPolylines = [];
    trafficLayer;

    handleApiLoaded(map, maps) {
        this.setState({map: map, maps: maps});
        this.addMetroData();
        this.trafficLayer = new maps.TrafficLayer();
        // this.addTrafficLayer();
    }

    clearComplianceCircles() {
        while (this.complianceOverlays.length) {
            this.complianceOverlays.pop().setMap(null);
        }
    }

    complianceCircle() {
        if (!this.props.showCompliance && this.complianceOverlays.length) {
            this.clearComplianceCircles();
        } else if (this.props.showCompliance && this.state.map && this.props.selectedBoard && (!this.complianceOverlays.length
            || (this.complianceOverlays[0].center && this.complianceOverlays[0].center.lat() !== this.props.selectedBoard.lat && this.complianceOverlays[0].center.lng() !== this.props.selectedBoard.lon))) {
            //add red circle to map
            this.clearComplianceCircles();
            let map = this.state.map;
            if(typeof this.props.selectedBoard.lat !== "number" || typeof this.props.selectedBoard.lon !== "number"){
                let lat = parseFloat(this.props.selectedBoard.lat);
                let lon = parseFloat(this.props.selectedBoard.lon);
                if(!isNaN(lat) && !isNaN(lon)){
                    this.props.selectedBoard.lat = lat
                    this.props.selectedBoard.lon = lon
                }
            }
            let complianceCircle = new this.state.maps.Circle({
                map,
                strokeColor: "#FF0000",
                strokeOpacity: 0.3,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.1,
                center: {lat: this.props.selectedBoard.lat, lng: this.props.selectedBoard.lon},
                radius: this.props.campaign && this.props.campaign.complianceRadius ? this.props.campaign.complianceRadius: 1610,
            })
            this.complianceOverlays.push(complianceCircle);
            let complianceCircle2 = new this.state.maps.Circle({
                map,
                strokeColor: "#FF0000",
                strokeOpacity: 0.3,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.1,
                center: {lat: this.props.selectedBoard.lat, lng: this.props.selectedBoard.lon},
                radius: this.props.campaign && this.props.campaign.complianceRadius ? this.props.campaign.complianceRadius * 2: 1610 *2,
            })
            this.complianceOverlays.push(complianceCircle2);

        }
    }

    showIncomeLayer() {
        if (this.state.map && this.state.maps && this.censusOverlays.length) {
            console.log("show income layer")
            for (let i = 0; i < this.censusOverlays.length; i++) {
                let overlay = this.censusOverlays[i];
                let censusData = this.props.overlays[i];
                // console.log(overlay)
                let fillOpacity = (0.9 * (censusData.medianHouseholdIncome / 250000));
                let fillColor = "#0066FF";
                // if(fillOpacity < 0.4){
                //     fillColor = "#515151";
                //     fillOpacity = 0.9 - fillOpacity;
                // }
                if (!censusData.medianHouseholdIncome) {
                    fillColor = "#515151";
                    fillOpacity = 0.0;
                }
                overlay.setOptions({
                    strokeColor: "#0066FF",
                    strokeOpacity: 0.1,
                    fillColor: fillColor,
                    fillOpacity: fillOpacity,
                })
            }
        }
        this.setState({selectedOverlayType: "income"});
    }
    showCommuteLayer() {
        if (this.state.map && this.state.maps && this.censusOverlays.length) {
            for (let i = 0; i < this.censusOverlays.length; i++) {
                let overlay = this.censusOverlays[i];
                let censusData = this.props.overlays[i];
                // console.log(overlay)
                let fillOpacity = ((censusData.commuters-30)/40);//[30 - 70]
                if(fillOpacity > 0.8){
                    fillOpacity = 0.8;
                }
                let fillColor = "#800080";
                // if(fillOpacity < 0.4){
                //     fillColor = "#515151";
                //     fillOpacity = 0.9 - fillOpacity;
                // }
                if (!censusData.commuters) {
                    fillColor = "#515151";
                    fillOpacity = 0.0;
                }
                overlay.setOptions({
                    strokeColor: "#800080",
                    strokeOpacity: 0.1,
                    fillColor: fillColor,
                    fillOpacity: fillOpacity,
                })
            }
        }
        this.setState({selectedOverlayType: "commuters"});
    }
    showAvgCarYear() {
        if (this.state.map && this.state.maps && this.censusOverlays.length) {
            for (let i = 0; i < this.censusOverlays.length; i++) {
                let overlay = this.censusOverlays[i];
                let censusData = this.props.overlays[i];
                // console.log(overlay)
                let fillOpacity = 0
                let fillColor = "#800080";
                let strokeColor = "#800080";
                if(censusData.avgCarYear >= 7){
                    fillOpacity = 1 - ((censusData.avgCarYear - 7) / 4)
                } else{
                    fillOpacity = 1 - ((7 - censusData.avgCarYear) / 2)
                    fillColor = "#0066FF";
                    strokeColor = "#0066FF";
                }
                if(fillOpacity > 0.8){
                    fillOpacity = 0.8;
                }
                // if(fillOpacity < 0.4){
                //     fillColor = "#515151";
                //     fillOpacity = 0.9 - fillOpacity;
                // }
                if (!censusData.avgCarYear) {
                    fillColor = "#515151";
                    fillOpacity = 0.0;
                }
                overlay.setOptions({
                    strokeColor: strokeColor,
                    strokeOpacity: 0.1,
                    fillColor: fillColor,
                    fillOpacity: fillOpacity,
                })
            }
        }
        this.setState({selectedOverlayType: "avgCarYear"});
    }
    heatmap;
    showAccidentHeatmap(){
        if (!this.state.map || !this.state.maps) {
            return
        }
        this.setState({showAccidents: true});
        if(this.heatmap){
            this.heatmap.setMap(this.state.map);
            return;
        }
        const heatmap = new this.state.maps.visualization.HeatmapLayer({
            data: this.props.accidents?.map(point => (
                {location: new this.state.maps.LatLng(point.lat, point.lon),
                    weight: point.severity})),
            options:{
                // dissipating:false,
                // gradient: ["rgba(255,51,0,0)",
                //     "rgb(248,157,26)",
                //     "rgb(193,109,0)",
                //     "rgb(210,97,0)",
                //     "rgb(189,104,0)",
                //     "rgba(127, 0, 63, 1)",
                //     "rgba(191, 0, 31, 1)",
                //     "rgba(255, 0, 0, 1)",],
                radius: 8,
            }
        });
        heatmap.setMap(this.state.map);
        this.heatmap = heatmap;
        let radius = this.state.map.zoom /(Math.pow(2,(20-this.state.map.zoom )));
        radius *= 800;
        heatmap.setOptions({radius: radius});
        console.log(radius);
        this.state.maps.event.addListener(this.state.map, 'zoom_changed', (ev) =>{
            let radius = this.state.map.zoom /(Math.pow(2,(20-this.state.map.zoom )));
            radius *= 800;
            console.log(radius);
            heatmap.setOptions({radius: radius});
        })
        // this.state.maps.event.addListener(this.state.map, 'zoom_changed', () =>{
        //     this.heatmap.setOptions({radius:10 * Math.pow(2,this.state.map.zoom)})
        // });
    }
    hideAccidentHeatmap(){
        this.setState({showAccidents: false});
        if(this.heatmap){
            this.heatmap.setMap(null);
        }
    }

    showPsychoLayer(field, multiplier = 2) {
        if (this.state.map && this.state.maps && this.censusOverlays.length) {
            console.log("show psycho layer")
            for (let i = 0; i < this.censusOverlays.length; i++) {
                let overlay = this.censusOverlays[i];
                let censusData = this.props.overlays[i];
                let fillColor = "#515151";
                let fillOpacity = 0.0;
                if(field === 'home_year_built' && censusData.psycho && censusData.psycho[field]){
                    fillOpacity = (censusData.psycho[field] - 1900) / 100;
                    if(fillOpacity > 0.9){
                        fillOpacity = 0.9;
                    }
                    fillColor = "#800080";
                } else if (censusData.psycho && censusData.psycho[field]) {
                    fillOpacity = (censusData.psycho[field] / censusData.psychoTotal) * multiplier;
                    if(fillOpacity > 0.9){
                        fillOpacity = 0.9;
                    }
                    fillColor = "#800080";
                }
                overlay.setOptions({
                    strokeColor: "#800080",
                    strokeOpacity: 0.1,
                    fillColor: fillColor,
                    fillOpacity: fillOpacity,
                })
                // if(fillOpacity < 0.4){
                //     fillColor = "#515151";
                //     fillOpacity = 0.9 - fillOpacity;
                // }

            }
        }
        this.setState({selectedOverlayType: field});
    }
    trafficOverlay;
    removeTrafficLayer(){
        this.state.map.overlayMapTypes.removeAt(0, this.trafficOverlay);
        this.trafficOverlay = undefined;
    }
    addTrafficLayer(){
        console.log(this.state.map.zoom)
        if(this.state.map.zoom-1 > 11){
            this.state.map.setZoom(12);
        }else if(this.state.map.zoom-1 < 9){
            this.state.map.setZoom(10);
        }
        this.trafficOverlay = new this.state.maps.ImageMapType({
            getTileUrl: function(coord, zoom) {
                if (zoom-1 < 9 || zoom-1 > 11){
                    return "";
                }
                return `https://storage.googleapis.com/telos-outdoor/telos/traffic/` + (zoom - 1)+ '/' +coord.x+ '/' + coord.y +'.png';
            },
            tileSize: new this.state.maps.Size(512, 512),
        });
        this.state.map.overlayMapTypes.insertAt(0, this.trafficOverlay);

    }

    showRaceLayer() {
        if (this.state.map && this.state.maps && this.censusOverlays.length) {
            console.log("show race & ethnicity layer");
            for (let i = 0; i < this.censusOverlays.length; i++) {
                let overlay = this.censusOverlays[i];
                let censusData = this.props.overlays[i];
                // console.log(overlay)
                let maxRace = {percent: 0, name: ""};
                for (let key in censusData.race) {
                    if (censusData.race.hasOwnProperty(key)) {
                        if (key.includes("Percent") && censusData.race[key] > maxRace.percent) {
                            maxRace = {percent: censusData.race[key], name: key};
                        }
                    }
                }
                let fillOpacity = maxRace.percent;
                let fillColor = "#515151";
                switch (maxRace.name) {
                    case "asianPercent":
                        fillColor = "hotpink";
                        break;
                    case "blackPercent":
                        fillColor = "purple";
                        break;
                    case "whitePercent":
                        fillColor = "#5273C9";
                        break;
                    case "hispanicPercent":
                        fillColor = "#E78E25";
                        break;
                    // case "otherPercent":
                    default:
                        fillColor = "#515151";
                        fillOpacity = 0.3;
                }
                // if(fillOpacity < 0.4){
                //     fillColor = "#515151";
                //     fillOpacity = 0.9 - fillOpacity;
                // }
                overlay.setOptions({
                    strokeColor: fillColor,
                    strokeOpacity: 0.1,
                    fillColor: fillColor,
                    fillOpacity: fillOpacity,
                })
            }
        }
        this.setState({selectedOverlayType: "race"});
    }

    initialOverlays() {
        if (this.state.map && this.state.maps && this.props.overlays && !this.censusOverlays.length) {
            let map = this.state.map;
            for (let overlay of this.props.overlays) {
                let polygon = new this.state.maps.Polygon({
                    // strokeColor: "#008000",
                    // strokeOpacity: 0.2,
                    strokeColor: "#FFFFFF",
                    strokeOpacity: 0.0,
                    strokeWeight: 1,
                    fillColor: "#FFFFFF",
                    fillOpacity: 0.0,
                    // fillColor: "#008000",
                    // fillOpacity: fillOpacity,
                    paths: overlay.coordinates
                })
                polygon.setMap(map);
                // console.log(overlay.coordinates);
                this.state.maps.event.addListener(polygon, "mouseover", () => {
                    this.setState({selectedCensus: overlay})
                });
                this.censusOverlays.push(polygon);
            }
        }
    }

    addMetroData() {
        let map = this.state.map;
        if(this.props.boards){
            for (let key of Object.keys(this.props.boards)) {
                let b = this.props.boards[key]
                if (b.coordinates) {
                    const path = new this.state.maps.Polyline({
                        path: b.coordinates,
                        geodesic: true,
                        strokeColor: "#515151",
                        strokeOpacity: 1.0,
                        strokeWeight: 3,
                        zIndex: 11,
                    });
                    const pathShadow = new this.state.maps.Polyline({
                        path: b.coordinates,
                        geodesic: true,
                        strokeColor: "#515151",
                        strokeOpacity: 0.1,
                        strokeWeight: 10,
                        zIndex: 10,
                    });
                    path.setMap(map);
                    pathShadow.setMap(map);
                    // this.state.maps.event.addListener(path, "mouseover", () => {
                    //     console.log("hover");
                    // });
                    this.metroMediaPolylines.push(path);
                    this.metroMediaPolylines.push(pathShadow);
                }
            }
        }
    }

    hideOverlays() {
        console.log("hide overlay")
        for (let co of this.censusOverlays) {
            co.setOptions({fillOpacity: 0.0, strokeOpacity: 0.0})
        }
        this.setState({selectedOverlayType: ""});
    }

    zoom = 11;
    defaultLanLon = {lat: 34.0522, lon: -118.2437};

    componentWillMount() {
        if (this.props.selectedBoard) {
            this.defaultLanLon.lat = this.props.selectedBoard.lat;
            this.defaultLanLon.lon = this.props.selectedBoard.lon;
        } else if (this.props.campaign && this.props.campaign.center) {
            if(this.props.campaign.center.lat !== 0.0){
                this.defaultLanLon.lat = this.props.campaign.center.lat;
                this.defaultLanLon.lon = this.props.campaign.center.lon;
            }
        }
        if (this.props.campaign && this.props.campaign.boundaries) {
            let b = this.props.campaign.boundaries;
            let d = b.right - b.left;
            this.zoom = Math.floor(Math.log2(5314.92 / d));
            // zoom = 15 - Math.floor(distance * 10);
        }
    }

    inviteOwner(email) {
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/share-campaign", {
            campaignId: this.props.campaign._id,
            email,
        }).then(() => {
            if (typeof this.props.refetchCampaign === 'function') {
                this.props.refetchCampaign();
            }
        }).catch(({ response }) => {
            const errorMsg = response?.data?.message || '';
            this.setState({
                error: {
                    title: "Error Inviting Owner!",
                    body: "Server reported an error: " + errorMsg,
                }
            });
        });
    }
   
    deleteOwner(email) {
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/delete-campaign-owner", {
            campaignId: this.props.campaign._id,
            email,
        }).then(() => {
            if (typeof this.props.refetchCampaign === 'function') {
                this.props.refetchCampaign();
            }
        }).catch(({ response }) => {
            const errorMsg = response?.data?.message || '';
            this.setState({
                error: {
                    title: "Error Deleting Owner!",
                    body: "Server reported an error: " + errorMsg,
                }
            });
        });
    }

    render() {
        let boards = this.props.boards;
        if (!boards) {
            boards = []
        }

        this.complianceCircle();
        this.initialOverlays();
        let selectedCensus = this.state.selectedCensus;
        if (!selectedCensus) {
            selectedCensus = {
                name: "",
                affGeoId: "Hover on an area to see data",
                medianHouseholdIncome: 0,

            }
        }
        let sharePopover = SharePopover({
            isOwner: this.props.isOwner,
            isPrimaryOwner: this.props.isPrimaryOwner,
            currentUserId: this.props.currentUserId,
            selectedBoard: this.props.selectedBoard,
            otherOwners: this.props.campaign.otherOwners,
            inviteOwner: this.inviteOwner.bind(this),
            deleteOwner: this.deleteOwner.bind(this),
        });
        let activity = ActivityTracker(boards);
        return (
            <>
                <GoogleMapReact
                    google={this.props.google}
                    zoom={this.zoom}
                    style={mapStyles}
                    defaultCenter={
                        {
                            lat: this.defaultLanLon.lat,
                            lng: this.defaultLanLon.lon
                        }
                    }
                    center={this.props.center ?
                        {
                            lat: this.props.center.lat,
                            lng: this.props.center.lon
                        } : {
                            lat: this.defaultLanLon.lat,
                            lng: this.defaultLanLon.lon
                        }
                    }
                    bootstrapURLKeys={{
                        key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
                        libraries:['visualization']
                    }}
                    options={(maps) => {
                        return {
                            streetViewControl: true,
                            styles: [{
                                featureType: "poi.business",
                                elementType: "labels",
                                stylers: [{
                                    visibility: "true"
                                }]
                            }],
                            fullscreenControl: false,
                            mapTypeControl: true,
                            // mapTypeId: maps.MapTypeId.SATELLITE,
                            mapTypeControlOptions: {
                                // style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
                                position: maps.ControlPosition.TOP_RIGHT,
                                mapTypeIds: [
                                    maps.MapTypeId.ROADMAP,
                                    maps.MapTypeId.HYBRID
                                ]
                            },
                            clickableIcons: false,
                        }
                    }}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({map, maps}) => this.handleApiLoaded(map, maps)}
                >
                    {boards ? (Object.keys(boards).map((boardKey,index) => {
                            if(!boardMatchesSearch( boards[boardKey],this.props.search,this.props.filters)){
                                return <></>
                            }
                            if (boards[boardKey].coordinates && boards[boardKey].coordinates.length >= 2) {
                                return boards[boardKey].coordinates.map((coordinate,index2) => {
                                    if(index2 === 0){
                                        return <BillboardPin
                                            campaign={this.props.campaign}
                                            key={index + "" + index2}
                                            boardKey={boardKey}
                                            board={boards[boardKey]}
                                            lat={coordinate.lat}
                                            lng={coordinate.lng}
                                            selectedBoard={this.props.selectedBoard}
                                            selectBoard={this.props.selectBoard}
                                            centerMap={this.props.centerMap}
                                            hoveredId={this.props.hoveredId}
                                            isOwner={this.props.isOwner}
                                            updateBoard={this.props.updateBoard}
                                        />
                                    }else if(index2 ===  boards[boardKey].coordinates.length-1){
                                        return <BillboardPin
                                            campaign={this.props.campaign}
                                            key={index + "" + index2}
                                            boardKey={boardKey}
                                            board={boards[boardKey]}
                                            lat={coordinate.lat}
                                            lng={coordinate.lng}
                                            selectedBoard={this.props.selectedBoard}
                                            selectBoard={this.props.selectBoard}
                                            centerMap={this.props.centerMap}
                                            isOwner={this.props.isOwner}
                                            updateBoard={this.props.updateBoard}
                                        />
                                    }else{
                                        return <></>
                                    }
                                })
                            } else {
                                return <BillboardPin
                                    hoveredId={this.props.hoveredId}
                                    campaign={this.props.campaign}
                                    key={index}
                                    boardKey={boardKey}
                                    board={boards[boardKey]}
                                    lat={boards[boardKey].lat}
                                    lng={boards[boardKey].lon}
                                    selectedBoard={this.props.selectedBoard}
                                    selectBoard={this.props.selectBoard}
                                    centerMap={this.props.centerMap}
                                    isOwner={this.props.isOwner}
                                    updateBoard={this.props.updateBoard}
                                />
                            }
                        }
                    )) : (<></>)}
                    {this.props.showCompliance && this.props.selectedBoard ? (
                        (this.props.selectedBoard.complianceArray.map((c, i) =>
                            <CompliancePin
                                key={i}
                                lat={c.lat}
                                lng={c.lon}
                                text={c.name}
                            />
                        ))
                    ) : (
                        <></>
                    )}
                    {this.state.showPOIs && this.props.campaign.POIsArray? (
                        (this.props.campaign.POIsArray.map((POI, index) =>
                            <POIsPin
                                poi={POI}
                                key={index}
                                lat={POI.lat}
                                lng={POI.lon}
                                poisLength={this.props.campaign.POIsArray.length}
                            />
                        ))
                    ) : (
                        <></>
                    )}
                </GoogleMapReact>
                <OverlayTrigger trigger="click" placement="bottom" overlay={sharePopover}>
                    <Button style={{position: "absolute", left: 8, top: 8, boxShadow: "0 4px 4px 0 rgba(0,0,0,0.25)"}}>
                        <img height={12} style={{marginRight: 8, marginBottom: 4}} src={shareImg} alt={"Share icon"}/>
                        Share
                    </Button>
                </OverlayTrigger>
                <Link target="_blank" to={`/campaigns/${this.props.campaign._id}/edit-boards?search=${this.props.search ? this.props.search :""}`}  style={{
                    position: "absolute",
                    left: 108,
                    top: 8,
                    boxShadow: "0 4px 4px 0 rgba(0,0,0,0.25)"
                }}
                      className={"btn btn-primary"}>
                    {/*d-block*/}
                    <img height={12} style={{marginRight: 8, marginBottom: 4}} src={exportImg} alt={"Export icon"}/>
                    Export
                </Link>
                <Link target="_blank" to={`/campaign/${this.props.campaign._id}/files`}  style={{
                    position: "absolute",
                    left: 218,
                    top: 8,
                    boxShadow: "0 4px 4px 0 rgba(0,0,0,0.25)"
                }}
                      className={"btn btn-primary"}>
                    {/*d-block*/}
                    File Manager
                </Link>
                {activity.confirmed ?
                    <div className={"activity-tracker"}>
                        <div style={{width: "calc(100% - 16px)", margin: "0 8px"}}>
                            <p>
                                Activity Tracker
                                <span style={{float: "right"}}>
                                    {activity.posted}/{activity.confirmed} Posted ({activity.postedPercent}%)
                                </span>
                            </p>
                            <div style={{
                                width: "100%",
                                background: "white",
                                "height": 18,
                                margin: "0 0 16px 0",
                                border: "1px solid lightgray",
                                fontSize: 0,
                            }}>
                                <div style={{width: activity.postedPercent + "%", background: "#f5e1a0", "height": 16}}>
                                </div>
                            </div>
                            <hr style={{margin: 0}}/>
                            <p>
                                Override
                                <span style={{float: "right"}}>
                                    {activity.override}%
                                </span>
                            </p>
                            <div style={{
                                width: "100%",
                                background: "white",
                                "height": 18,
                                margin: "0 0 16px 0",
                                border: "1px solid lightgray",
                                fontSize: 0,
                            }}>
                                <div style={{width: activity.override + "%", background: "#f5e1a0", "height": 16}}>
                                </div>
                            </div>
                        </div>
                    </div> :""
                }
                {selectedCensus ?//todo: add clear overlays if none selected
                    <div className={"selected-census-info"}>
                        <table>
                            <tbody>
                            <tr>
                                <th colSpan={3} className={""}>
                                    {selectedCensus.zipcode}
                                    {selectedCensus.name.split(",").length > 3 ?
                                        selectedCensus.name.split(",")[0] + ", " + selectedCensus.name.split(",")[2]
                                        : selectedCensus.affGeoId}
                                </th>
                            </tr>
                            {this.props.overlays && this.props.overlays.length ?
                            <>
                                <tr>
                                    <td colSpan={3}>
                                        <table className={"census-sub-table"}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {this.state.selectedOverlayType === "income" ?
                                                        <div className={"radio"} onClick={() => {
                                                            this.hideOverlays();
                                                        }}>
                                                            <div className={"selected"}/>
                                                        </div>
                                                        :
                                                        <div className={"radio"} onClick={() => {
                                                            this.showIncomeLayer();
                                                        }}/>
                                                    }
                                                </td>
                                                <th>Median Household Income</th>
                                                <td className={"td-value"}>
                                                    {selectedCensus.medianHouseholdIncome ? (
                                                            "$" + (selectedCensus.medianHouseholdIncome > 250000 ? "250k+"
                                                                : selectedCensus.medianHouseholdIncome)
                                                        ) :
                                                        "No data"
                                                    }</td>
                                            </tr>
                                            {this.state.selectedOverlayType === "income" ?
                                                <tr>
                                                    <td/>
                                                    <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                $0
                                                            </div>
                                                            <div className={"transparency-scale"}/>
                                                            <div>
                                                                $250k+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <table className={"race-table"}>
                                            <tbody>
                                            <tr>
                                                <td className={"radio-container"}>
                                                    {this.state.selectedOverlayType === "race" ?
                                                        <div className={"radio"} onClick={() => {
                                                            this.hideOverlays();
                                                        }}>
                                                            <div className={"selected"}/>
                                                        </div>
                                                        :
                                                        <div className={"radio"} onClick={() => {
                                                            this.showRaceLayer();
                                                        }}/>
                                                    }
                                                </td>
                                                <th style={{padding: 0, paddingTop: "1px"}} colSpan={4}>Race & Ethnicity
                                                </th>
                                            </tr>
                                            <tr>
                                                <td/>
                                                <th>White</th>
                                                <td className={"percent-txt"}> {selectedCensus.race && selectedCensus.race.whitePercent ? (
                                                        (selectedCensus.race.whitePercent > 1 ? "98"
                                                            : Math.round(selectedCensus.race.whitePercent * 100))
                                                    ) :
                                                    "--"
                                                }%{this.state.selectedOverlayType === "race" ?
                                                    <div className={"white-legend"}/> : <></>}
                                                    &nbsp;&nbsp;</td>
                                                <th>&nbsp;&nbsp;Asian</th>
                                                <td className={"percent-txt"}> {selectedCensus.race && selectedCensus.race.asianPercent ? (
                                                        (selectedCensus.race.asianPercent > 1 ? "98"
                                                            : Math.round(selectedCensus.race.asianPercent * 100))
                                                    ) :
                                                    "--"
                                                }%{this.state.selectedOverlayType === "race" ?
                                                    <div className={"asian-legend"}/> : <></>}
                                                    &nbsp;&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td/>
                                                <th>Hispanic</th>
                                                <td className={"percent-txt"}> {selectedCensus.race && selectedCensus.race.hispanicPercent ? (
                                                        (selectedCensus.race.hispanicPercent > 1 ? "98"
                                                            : Math.round(selectedCensus.race.hispanicPercent * 100))
                                                    ) :
                                                    "--"
                                                }%{this.state.selectedOverlayType === "race" ?
                                                    <div className={"hispanic-legend"}/> : <></>}
                                                    &nbsp;&nbsp;</td>
                                                <th>&nbsp;&nbsp;Black</th>
                                                <td className={"percent-txt"}> {selectedCensus.race && selectedCensus.race.blackPercent ? (
                                                        (selectedCensus.race.blackPercent > 1 ? "98"
                                                            : Math.round(selectedCensus.race.blackPercent * 100))
                                                    ) :
                                                    "--"
                                                }%{this.state.selectedOverlayType === "race" ?
                                                    <div className={"black-legend"}/> : <></>}
                                                    &nbsp;&nbsp;</td>
                                            </tr>
                                            {/*<tr>*/}
                                            {/*    <td/>*/}
                                            {/*    <th>Other</th>*/}
                                            {/*    <td className={"percent-txt"}> {selectedCensus.race && selectedCensus.race.otherPercent ? (*/}
                                            {/*            (selectedCensus.race.otherPercent > 1 ? "98"*/}
                                            {/*                : Math.round(selectedCensus.race.otherPercent * 100))*/}
                                            {/*        ) :*/}
                                            {/*        "--"*/}
                                            {/*    }%&nbsp;&nbsp;</td>*/}
                                            {/*</tr>*/}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                {/*TODO: campaign.overlays.includes("auto_work") ? and for the other ones*/}
                                {this.props.campaign.name.includes("Autozone") ?
                                    <tr>
                                        <td colSpan={3}>
                                            <table className={"census-sub-table"}>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        {this.state.selectedOverlayType === "avgCarYear" ?
                                                            <div className={"radio"} onClick={() => {
                                                                this.hideOverlays();
                                                            }}>
                                                                <div className={"selected"}/>
                                                            </div>
                                                            :
                                                            <div className={"radio"} onClick={() => {
                                                                this.showAvgCarYear();
                                                            }}/>
                                                        }
                                                    </td>
                                                    <th>Avg. Car Age</th>
                                                    <td className={"td-value"}>
                                                        {selectedCensus &&  selectedCensus["avgCarYear"] ?
                                                            Math.round(selectedCensus["avgCarYear"] * 100)/100 : "No data"
                                                        }</td>
                                                </tr>
                                                {this.state.selectedOverlayType === "avgCarYear" ?
                                                    <>
                                                        <tr>
                                                            <td/>
                                                            <td colSpan={2}>
                                                                <div className={"transparency-legend"}>
                                                                    <div>
                                                                        +15y
                                                                    </div>
                                                                    <div className={"transparency-scale purple"}/>
                                                                    <div>
                                                                        7y
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td/>
                                                            <td colSpan={2}>
                                                                <div className={"transparency-legend"}>
                                                                    <div>
                                                                        0y
                                                                    </div>
                                                                    <div className={"transparency-scale blue"}/>
                                                                    <div>
                                                                        7y
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </> : <></>}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>:""}
                                {this.props.campaign.name.includes("Autozone") ?
                                <tr>
                                    <td colSpan={3}>
                                        <table className={"census-sub-table"}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {this.state.selectedOverlayType === "auto_work" ?
                                                        <div className={"radio"} onClick={() => {
                                                            this.hideOverlays();
                                                        }}>
                                                            <div className={"selected"}/>
                                                        </div>
                                                        :
                                                        <div className={"radio"} onClick={() => {
                                                            this.showPsychoLayer("auto_work",1.5);
                                                        }}/>
                                                    }
                                                </td>
                                                <th>Auto Work</th>
                                                <td className={"td-value"}>
                                                    {selectedCensus.psycho &&  selectedCensus.psycho["auto_work"] ? (
                                                            (selectedCensus.psycho["auto_work"]/selectedCensus.psychoTotal > 1 ? "100%"
                                                                : Math.round((selectedCensus.psycho["auto_work"]/selectedCensus.psychoTotal)*100) +"%" )
                                                        ) :
                                                        "No data"
                                                    }</td>
                                            </tr>
                                            {this.state.selectedOverlayType === "auto_work" ?
                                                <tr>
                                                    <td/>
                                                    <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                0%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                75%+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>:""}
                                {this.props.campaign.name.includes("Legal")||this.props.campaign.name.includes("Celino")||this.props.campaign.name.includes("Karns")||this.props.campaign.name.includes("HVAC")  ?
                                    <tr>
                                    <td colSpan={3}>
                                        <table className={"census-sub-table"}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {this.state.selectedOverlayType === "commuters" ?
                                                        <div className={"radio"} onClick={() => {
                                                            this.hideOverlays();
                                                        }}>
                                                            <div className={"selected"}/>
                                                        </div>
                                                        :
                                                        <div className={"radio"} onClick={() => {
                                                            this.showCommuteLayer();
                                                        }}/>
                                                    }
                                                </td>
                                                <th>Commuters</th>
                                                <td className={"td-value"}>
                                                    {selectedCensus["commuters"] &&  selectedCensus["commuters"] ?
                                                        Math.round((selectedCensus["commuters"])) +"%":
                                                        "No data"
                                                    }</td>
                                            </tr>
                                            {this.state.selectedOverlayType === "commuters" ?
                                                <tr>
                                                    <td/>
                                                    <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                20%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                100%
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>:""}
                                {this.props.campaign.name.includes("Autozone")?
                                    <tr>
                                        <td colSpan={3}>
                                            <table className={"census-sub-table"}>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        {this.state.selectedOverlayType === "hiking" ?
                                                            <div className={"radio"} onClick={() => {
                                                                this.hideOverlays();
                                                            }}>
                                                                <div className={"selected"}/>
                                                            </div>
                                                            :
                                                            <div className={"radio"} onClick={() => {
                                                                this.showPsychoLayer("hiking");
                                                            }}/>
                                                        }
                                                    </td>
                                                    <th>Outdoors</th>
                                                    <td className={"td-value"}>
                                                        {selectedCensus.psycho &&  selectedCensus.psycho["hiking"] ? (
                                                                (selectedCensus.psycho["hiking"]/selectedCensus.psychoTotal > 1 ? "100%+"
                                                                    : Math.round((selectedCensus.psycho["hiking"]/selectedCensus.psychoTotal)*100) +"%" )
                                                            ) :
                                                            "No data"
                                                        }</td>
                                                </tr>
                                                {this.state.selectedOverlayType === "hiking" ?
                                                    <tr>
                                                        <td/>
                                                        <td colSpan={2}>
                                                            <div className={"transparency-legend"}>
                                                                <div>
                                                                    0%
                                                                </div>
                                                                <div className={"transparency-scale purple"}/>
                                                                <div>
                                                                    50%+
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr> : <></>}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>:""}
                                <tr className={"d-none"}>
                                    <td colSpan={3}>
                                        <table className={"census-sub-table"}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {this.state.selectedOverlayType === "nascar" ?
                                                        <div className={"radio"} onClick={() => {
                                                            this.hideOverlays();
                                                        }}>
                                                            <div className={"selected"}/>
                                                        </div>
                                                        :
                                                        <div className={"radio"} onClick={() => {
                                                            this.showPsychoLayer("nascar",5);
                                                        }}/>
                                                    }
                                                </td>
                                                <th>Nascar</th>
                                                <td className={"td-value"}>
                                                    {selectedCensus.psycho &&  selectedCensus.psycho["nascar"] ? (
                                                            (selectedCensus.psycho["nascar"]/selectedCensus.psychoTotal > 1 ? "100%"
                                                                : Math.round((selectedCensus.psycho["nascar"]/selectedCensus.psychoTotal)*100) +"%" )
                                                        ) :
                                                        "No data"
                                                    }</td>
                                            </tr>
                                            {this.state.selectedOverlayType === "nascar" ?
                                                <tr>
                                                    <td/>
                                                    <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                0%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                20%+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                {this.props.campaign.name.includes("Body") ? <tr>
                                    <td colSpan={3}>
                                        <table className={"census-sub-table"}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {this.state.selectedOverlayType === "cosmetics" ?
                                                        <div className={"radio"} onClick={() => {
                                                            this.hideOverlays();
                                                        }}>
                                                            <div className={"selected"}/>
                                                        </div>
                                                        :
                                                        <div className={"radio"} onClick={() => {
                                                            this.showPsychoLayer("cosmetics",10);
                                                        }}/>
                                                    }
                                                </td>
                                                <th>Cosmetics</th>
                                                <td className={"td-value"}>
                                                    {selectedCensus.psycho &&  selectedCensus.psycho["cosmetics"] ? (
                                                            (selectedCensus.psycho["cosmetics"]/selectedCensus.psychoTotal > 1 ? "100%+"
                                                                : Math.round((selectedCensus.psycho["cosmetics"]/selectedCensus.psychoTotal)*100) +"%" )
                                                        ) :
                                                        "No data"
                                                    }</td>
                                            </tr>
                                            {this.state.selectedOverlayType === "cosmetics" ?
                                                <tr>
                                                    <td/>
                                                    <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                0%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                10%+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>:""}
                                {this.props.campaign.name.includes("Body") ? <tr>
                                    <td colSpan={3}>
                                        <table className={"census-sub-table"}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {this.state.selectedOverlayType === "health_beauty" ?
                                                        <div className={"radio"} onClick={() => {
                                                            this.hideOverlays();
                                                        }}>
                                                            <div className={"selected"}/>
                                                        </div>
                                                        :
                                                        <div className={"radio"} onClick={() => {
                                                            this.showPsychoLayer("health_beauty",10);
                                                        }}/>
                                                    }
                                                </td>
                                                <th>Health Body</th>`
                                                <td className={"td-value"}>
                                                    {selectedCensus.psycho &&  selectedCensus.psycho["health_beauty"] ? (
                                                            (selectedCensus.psycho["health_beauty"]/selectedCensus.psychoTotal > 1 ? "100%+"
                                                                : Math.round((selectedCensus.psycho["health_beauty"]/selectedCensus.psychoTotal)*100) +"%" )
                                                        ) :
                                                        "No data"
                                                    }</td>
                                            </tr>
                                            {this.state.selectedOverlayType === "health_body" ?
                                                <tr>
                                                    <td/>
                                                    <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                0%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                10%+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>:""}
                                {this.props.campaign.name.includes("Karns") ||this.props.campaign.name.includes("Celino")?
                                    <tr>
                                        <td colSpan={3}>
                                            <table className={"census-sub-table"}>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        {this.state.selectedOverlayType === "blue_collar_worker" ?
                                                            <div className={"radio"} onClick={() => {
                                                                this.hideOverlays();
                                                            }}>
                                                                <div className={"selected"}/>
                                                            </div>
                                                            :
                                                            <div className={"radio"} onClick={() => {
                                                                this.showPsychoLayer("blue_collar_worker",15);
                                                            }}/>
                                                        }
                                                    </td>
                                                    <th>Blue Collar</th>
                                                    <td className={"td-value"}>
                                                        {selectedCensus.psycho &&  selectedCensus.psycho["blue_collar_worker"] ? (
                                                                (selectedCensus.psycho["blue_collar_worker"]/selectedCensus.psychoTotal > 1 ? "100%+"
                                                                    : Math.round((selectedCensus.psycho["blue_collar_worker"]/selectedCensus.psychoTotal)*100) +"%" )
                                                            ) :
                                                            "No data"
                                                        }</td>
                                                </tr>
                                                {this.state.selectedOverlayType === "blue_collar_worker" ?
                                                    <tr>
                                                        <td/>
                                                        <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                0%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                7%+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>:""}
                                {this.props.campaign._id === "6a43f6dccee914f2cac9c3dd" ?
                                    <tr>
                                        <td colSpan={3}>
                                            <table className={"census-sub-table"}>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        {this.state.selectedOverlayType === "new_mom" ?
                                                            <div className={"radio"} onClick={() => {
                                                                this.hideOverlays();
                                                            }}>
                                                                <div className={"selected"}/>
                                                            </div>
                                                            :
                                                            <div className={"radio"} onClick={() => {
                                                                this.showPsychoLayer("new_mom",5);
                                                            }}/>
                                                        }
                                                    </td>
                                                    <th>New Moms</th>
                                                    <td className={"td-value"}>
                                                        {selectedCensus.psycho &&  selectedCensus.psycho["new_mom"] ? (
                                                                (selectedCensus.psycho["new_mom"]/selectedCensus.psychoTotal > 1 ? "100%+"
                                                                    : Math.round((selectedCensus.psycho["new_mom"]/selectedCensus.psychoTotal)*100) +"%" )
                                                            ) :
                                                            "No data"
                                                        }</td>
                                                </tr>
                                                {this.state.selectedOverlayType === "new_mom" ?
                                                    <tr>
                                                        <td/>
                                                        <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                0%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                16%+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                                <tr>
                                                    <td>
                                                        {this.state.selectedOverlayType === "whiskey" ?
                                                            <div className={"radio"} onClick={() => {
                                                                this.hideOverlays();
                                                            }}>
                                                                <div className={"selected"}/>
                                                            </div>
                                                            :
                                                            <div className={"radio"} onClick={() => {
                                                                this.showPsychoLayer("whiskey",4);
                                                            }}/>
                                                        }
                                                    </td>
                                                    <th>Whiskey Drinkers</th>
                                                    <td className={"td-value"}>
                                                        {selectedCensus.psycho &&  selectedCensus.psycho["whiskey"] ? (
                                                                (selectedCensus.psycho["whiskey"]/selectedCensus.psychoTotal > 1 ? "100%+"
                                                                    : Math.round((selectedCensus.psycho["whiskey"]/selectedCensus.psychoTotal)*100) +"%" )
                                                            ) :
                                                            "No data"
                                                        }</td>
                                                </tr>
                                                {this.state.selectedOverlayType === "whiskey" ?
                                                    <tr>
                                                        <td/>
                                                        <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                0%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                21%+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                                <tr>
                                                    <td>
                                                        {this.state.selectedOverlayType === "empty_nester" ?
                                                            <div className={"radio"} onClick={() => {
                                                                this.hideOverlays();
                                                            }}>
                                                                <div className={"selected"}/>
                                                            </div>
                                                            :
                                                            <div className={"radio"} onClick={() => {
                                                                this.showPsychoLayer("empty_nester",3);
                                                            }}/>
                                                        }
                                                    </td>
                                                    <th>Empty Nesters</th>
                                                    <td className={"td-value"}>
                                                        {selectedCensus.psycho &&  selectedCensus.psycho["empty_nester"] ? (
                                                                (selectedCensus.psycho["empty_nester"]/selectedCensus.psychoTotal > 1 ? "100%+"
                                                                    : Math.round((selectedCensus.psycho["empty_nester"]/selectedCensus.psychoTotal)*100) +"%" )
                                                            ) :
                                                            "No data"
                                                        }</td>
                                                </tr>
                                                {this.state.selectedOverlayType === "empty_nester" ?
                                                    <tr>
                                                        <td/>
                                                        <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                0%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                26%+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                                <tr>
                                                    <td>
                                                        {this.state.selectedOverlayType === "movie" ?
                                                            <div className={"radio"} onClick={() => {
                                                                this.hideOverlays();
                                                            }}>
                                                                <div className={"selected"}/>
                                                            </div>
                                                            :
                                                            <div className={"radio"} onClick={() => {
                                                                this.showPsychoLayer("movie",1.5);
                                                            }}/>
                                                        }
                                                    </td>
                                                    <th>Movie/Entertainment</th>
                                                    <td className={"td-value"}>
                                                        {selectedCensus.psycho &&  selectedCensus.psycho["movie"] ? (
                                                                (selectedCensus.psycho["movie"]/selectedCensus.psychoTotal > 1 ? "100%+"
                                                                    : Math.round((selectedCensus.psycho["movie"]/selectedCensus.psychoTotal)*100) +"%" )
                                                            ) :
                                                            "No data"
                                                        }</td>
                                                </tr>
                                                {this.state.selectedOverlayType === "movie" ?
                                                    <tr>
                                                        <td/>
                                                        <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                0%
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                49%+
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>:""}

                                {this.props.campaign.name.includes("Karns") ||this.props.campaign.name.includes("Celino") ||this.props.campaign.name.includes("Home Year") ||this.props.campaign.name.includes("Legal") ||this.props.campaign.name.includes("HVAC") ?
                                <tr>
                                    <td colSpan={3}>
                                        <table className={"census-sub-table"}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {this.state.selectedOverlayType === "home_year_built" ?
                                                        <div className={"radio"} onClick={() => {
                                                            this.hideOverlays();
                                                        }}>
                                                            <div className={"selected"}/>
                                                        </div>
                                                        :
                                                        <div className={"radio"} onClick={() => {
                                                            this.showPsychoLayer("home_year_built");
                                                        }}/>
                                                    }
                                                </td>
                                                <th>Avg. Home Year Built</th>
                                                <td className={"td-value"}>
                                                    {selectedCensus.psycho &&  selectedCensus.psycho["home_year_built"] ?
                                                        Math.round(selectedCensus.psycho["home_year_built"]):"No data"
                                                    }</td>
                                            </tr>
                                            {this.state.selectedOverlayType === "home_year_built" ?
                                                <tr>
                                                    <td/>
                                                    <td colSpan={2}>
                                                        <div className={"transparency-legend"}>
                                                            <div>
                                                                1900
                                                            </div>
                                                            <div className={"transparency-scale purple"}/>
                                                            <div>
                                                                2000
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr> : <></>}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                :""}
                                {this.props.campaign.name.includes("Karns") || this.props.campaign.name.includes("Jacoby")||this.props.campaign.name.includes("Celino") ||this.props.campaign.name.includes("Legal") ||this.props.campaign.name.includes("HVAC") ?
                                <tr>
                                    <td colSpan={3}>
                                        <table className={"census-sub-table"}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    {this.state.showAccidents ?
                                                        <div className={"radio"} onClick={()=>{this.hideAccidentHeatmap()}}>
                                                            <div className={"selected"}/>
                                                        </div>
                                                        :
                                                        <div className={"radio"} onClick={()=>{this.showAccidentHeatmap()}}/>
                                                    }
                                                </td>
                                                {this.props.accidents?.length ?
                                                    <th>{this.props.campaign.name.includes("Autozone")? "Breakdowns" : "Accidents Index"}</th> :
                                                    <th>{this.props.campaign.name.includes("Autozone")? "Breakdowns Loading..." : "Accidents Index Loading..."}</th>}
                                                <td className={"td-value position-relative"}/>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                :""}
                            </> :<>
                                    {!this.props.campaign.name.includes("CTG") ?
                                        <tr style={{"height":64}}>
                                            <img src={loadingSvg} className={"w-25 m-auto d-block"}/>
                                        </tr> : <></>
                                    }
                                </>}
                            {this.props.campaign.name.includes("Autozone") || this.props.campaign.name.includes("Legal") ||this.props.campaign.name.includes("HVAC") ?<tr>
                                <td colSpan={3}>
                                    <table className={"census-sub-table"}>
                                        <tbody>
                                        <tr>
                                            <td>
                                                {this.state.showTraffic ?
                                                    <div className={"radio"} onClick={() => {
                                                        this.setState({showTraffic:false});
                                                        // this.trafficLayer.setMap(null);
                                                        this.removeTrafficLayer();
                                                    }}>
                                                        <div className={"selected"}/>
                                                    </div>
                                                    :
                                                    <div className={"radio"} onClick={() => {
                                                        this.setState({showTraffic:true});
                                                        // this.trafficLayer.setMap(this.state.map);
                                                        this.addTrafficLayer();
                                                    }}/>
                                                }
                                            </td>
                                            <th>Traffic</th>
                                            <td className={"td-value position-relative"}/>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>:""}

                            <tr>
                                <td colSpan={3}>
                                    <table className={"census-sub-table"}>
                                        <tbody>
                                        <tr>
                                            <td>
                                                {this.state.showPOIs ?
                                                    <div className={"radio"} onClick={() => {
                                                        this.setState({showPOIs:false});
                                                    }}>
                                                        <div className={"selected"}/>
                                                    </div>
                                                    :
                                                    <div className={"radio"} onClick={() => {
                                                        this.setState({showPOIs:true});
                                                    }}/>
                                                }
                                            </td>
                                            <th>POIs</th>
                                            <td className={"td-value position-relative"}/>
                                        </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            {/*<td colSpan={3}>*/}
                            {/*    <table className={"census-sub-table"}>*/}
                            {/*        <tbody>*/}
                            {/*        <tr>*/}
                            {/*            <td>*/}
                            {/*                <div className={"radio invalid-cursor"}/>*/}
                            {/*            </td>*/}
                            {/*            <th>Average Age</th>*/}
                            {/*            <td className={"td-value"}>---</td>*/}
                            {/*        </tr>*/}
                            {/*        {this.state.selectedOverlayType === "age" ?*/}
                            {/*            <tr>*/}
                            {/*                <td/>*/}
                            {/*                <td>*/}
                            {/*                    $0 -> $250k+*/}
                            {/*                </td>*/}
                            {/*            </tr> : <></>}*/}
                            {/*        </tbody>*/}
                            {/*    </table>*/}
                            {/*</td>*/}
                            </tbody>
                        </table>
                    </div> : <></>
                }
                {this.state.error && (
                    <Alert 
                        className="mx-auto alert-top-right w-50" 
                        variant="danger" 
                        onClose={() => { this.setState({ error: null }) }} 
                        dismissible
                    >
                        <Alert.Heading>{this.state.error?.title}</Alert.Heading>
                        <p>{this.state.error?.body}</p>
                    </Alert>
                )}
            </>
        );
    }
}

class BillboardPin extends Component {
    state = {
        hovered: false
    };

    onMouseEnter() {
        this.setState({hovered: true})
    }

    onMouseLeave() {
        this.setState({hovered: false})
    }

    render() {
        //todo: one set of class declarations. Ex, dont need 2 hovered
        let url = new URLSearchParams(window.location.search);
        let childBoardsIds = this.props.board.childBoards ?
            this.props.board.childBoards.map(b => b.vendorId) :
            [];
        return <div
            onMouseEnter={() => this.onMouseEnter()}
            onMouseLeave={() => this.onMouseLeave()}
            onClick={() => {
                this.props.selectBoard(this.props.boardKey)
            }}
            className={`map-pin-default-container
                        rotate-${this.props.board.fields.facing ? this.props.board.fields.facing.toLowerCase() : ""}
                        ${this.state.hovered || [this.props.board.vendorId,  ...childBoardsIds].includes(this.props.hoveredId) ? ' hovered' : ''}
                        ${(this.props.selectedBoard && this.props.selectedBoard.vendorId === this.props.board.vendorId ? " selected" : "")}
                        `}>
            <div className={`map-pin-default
            rotate-${this.props.board.fields.facing ? this.props.board.fields.facing.toLowerCase() : ""}
            ${this.props.board.fields["media format"] ? " " + this.props.board.fields["media format"].toLowerCase() : ""}
            ${this.props.board.fields["digital (y/n)"] === "Y" ? " digital" : ""}
            ${this.state.hovered || [this.props.board.vendorId,  ...childBoardsIds].includes(this.props.hoveredId) ? ' hovered' : ''}
            ${this.props.selectedBoard && this.props.selectedBoard.vendorId === this.props.board.vendorId ? " selected" : ""}
            `}>
                {this.props.board.status === "favorite" ? <div className={"heart-container favorite"}><HeartSVG/></div> : ""}
            </div>
            {this.state.hovered || [this.props.board.vendorId, ...childBoardsIds].includes(this.props.hoveredId) ?
                <div
                    className={"board-card-on-pin " + (this.props.board.fields.facing ? this.props.board.fields.facing.toLowerCase() : "")}>
                    {(url.get("sidebarFormat") === "rows" || !url.get("sidebarFormat")) ?
                        <BoardCardTreeWrapper
                            selectBoard={this.props.selectBoard}
                            boardKey={this.props.boardKey}
                            isOwner={this.props.isOwner}
                            updateBoard={this.props.updateBoard}
                            campaign={this.props.campaign}
                            board={this.props.board}
                            pin
                        /> :
                    <BoardCard
                        boardKey={this.props.boardKey}
                        campaign={this.props.campaign}
                        isOwner={this.props.isOwner}
                        selectBoard={this.props.selectBoard}
                        updateBoard={this.props.updateBoard}
                        board={this.props.board}
                    />}
                </div>
                : <></>}
        </div>
    }
}

class CompliancePin extends Component {
    state = {};
    onMouseEnter(){
        this.setState({hovered:true})
    }
    onMouseLeave(){
        this.setState({hovered:false})
    }
    render() {
        return <div
            onMouseEnter={() => this.onMouseEnter()}
            onMouseLeave={() => this.onMouseLeave()}
            className={this.state.hovered ? 'map-pin-compliance hovered' : 'map-pin-compliance'}
        >
            {this.state.hovered ?
                <div className={"default-pin-title"}>
                    {this.props.text}
                </div>
                : <></>}
        </div>
    }
}

class POIsPin extends Component {
    state = {};
    onMouseEnter(){
        this.setState({hovered:true})
    }
    onMouseLeave(){
        this.setState({hovered:false})
    }
    render() {
        let className = this.state.hovered ? 'map-pin-poi hovered' : 'map-pin-poi';
        let customImg = "";
        let poi = this.props.poi;
        if (poi.name && poi.name.toLowerCase().includes("autozone")){
            if (this.props.poisLength < 250) {
                className += " large-pin";
                customImg = AutozoneImg
                className += " autozone-pin";
            } else {
                className += " autozone-pin";
            }
        }
        if (poi.category?.toLowerCase().includes("dispensary")){
            if (this.props.poisLength < 250) {
                className += " large-pin";
                customImg = MedPotCross
                className += " dispensary-pin";
            } else {
                className += " dispensary-pin";
            }
        }
        // else if(poi && poi.name.toLowerCase().includes("o'reilly") && this.props.poisLength < 250) {
        //     className += " large-pin";
        //     customImg = OreillyImg
        // }else

        // className += " large-pin";
        // customImg = AutozoneImg
        // customImg = AutozoneImg
        // else if(poi && poi.name.toLowerCase().includes("o'reilly") && this.props.poisLength < 250) {
        //     className += " large-pin";
        //     customImg = OreillyImg
        // }else
        if(poi && poi.category.toLowerCase().includes("hospital")) {
            className += " hospital-pin";
        }
        if(this.props.poisLength > 250){
            className += " sm-poi-pin";
        }
        return <div
            onMouseEnter={()=>this.onMouseEnter()}
            onMouseLeave={()=>this.onMouseLeave()}
            className={className}
        >
            <div className={"map-pin-bottom"}/>
            <div className={"map-pin-top"}
                 style={{backgroundImage:`url('${customImg}')`}}
            />
            {this.state.hovered ?
                <div className={"default-pin-title"}>
                    {poi.name}
                </div>
                : <></>}
        </div>
    }
}

function SharePopover({ isOwner, isPrimaryOwner, currentUserId, selectedBoard, otherOwners, inviteOwner, deleteOwner }) {
    //todo: check works on safari
    function Copy(str, ev){
        navigator.clipboard.writeText(str);
        console.log(ev);
        ev.currentTarget.innerHTML = "Copied!";
    }

    function getSelectedBoardUrl() {
        const url = new URLSearchParams(window.location.search);
        return `${window.location.origin}${window.location.pathname}?board=${url.get("board")}`;
    }
    
    function getCampaignUrl() {
        const url = new URLSearchParams(window.location.search);
        url.delete("board");
        return `${window.location.origin}${window.location.pathname}?${url.toString()}`;
    }
    
    function getUploadUrl() {
        return `${window.location.origin}${window.location.pathname}/upload`;
    }

    return <Popover id={"share-popover"} style={{ maxWidth: 405 }}>
        <h5>Campaign</h5>
        <input readOnly value={getCampaignUrl()}/>
        <button className={"btn btn-primary"} onClick={(ev) => Copy(getCampaignUrl(), ev)}>
            <CopySVG/>
        </button>
        {selectedBoard ? <>
            <hr/>
            <h5>Selected Board</h5>
            <input readOnly value={getSelectedBoardUrl()}/>
            <button className={"btn btn-primary"} onClick={(ev) => Copy(getSelectedBoardUrl(), ev)}>
                <CopySVG/>
            </button>
        </> : <></>}
        {isOwner ? <>
            <hr/>
            <h5>Upload Page</h5>
            <input readOnly value={getUploadUrl()}/>
            <button className={"btn btn-primary"} onClick={(ev) => Copy(getUploadUrl(), ev)}>
                <CopySVG/>
            </button>
        </> : <></>}
        {isOwner && <>
            <hr />
            <h5>Invite Owner</h5>
            <InviteOwnerForm
                currentUserId={currentUserId}
                isPrimaryOwner={isPrimaryOwner}
                otherOwners={otherOwners}
                inviteOwner={inviteOwner}
                deleteOwner={deleteOwner}
            />
        </>}
    </Popover>
}
